<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="prijs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs </th>
        <td mat-cell *matCellDef="let row">€ {{row.prijs?.toFixed(2)}}</td>
    </ng-container>

	<ng-container matColumnDef="datum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum </th>
        <td mat-cell *matCellDef="let row"> {{row.datum | date}} </td>
    </ng-container>

</mg-table>
